/* Usage:
 * <div data-controller="hex-color-picker">
 *   <input type="text" data-hex-color-picker-target="text" data-action="input->hex-color-picker#syncFromText change->hex-color-picker#syncFromText">
 *   <input type="color" data-hex-color-picker-target="picker" data-action="input->hex-color-picker#syncFromPicker change->hex-color-picker#syncFromPicker">
 * </div>
 */
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "picker"]

  connect() {
    this.syncFromText()
  }

  syncFromPicker() {
    this.textTarget.value = this.pickerTarget.value
  }

  syncFromText() {
    const hex = this.normalizedHex(this.textTarget.value)
    if (hex) {
      this.pickerTarget.value = hex
    }
  }

  // Native color inputs only accept #rrggbb. Expand #rgb and add a missing # when possible.
  normalizedHex(value) {
    if (!value) return null

    let hex = value.trim()
    if (!hex.startsWith("#")) {
      hex = `#${hex}`
    }

    const shortMatch = hex.match(/^#([0-9a-fA-F]{3})$/)
    if (shortMatch) {
      const [r, g, b] = shortMatch[1].split("")
      hex = `#${r}${r}${g}${g}${b}${b}`
    }

    if (/^#[0-9a-fA-F]{6}$/.test(hex)) {
      return hex.toLowerCase()
    }

    return null
  }
}
